import useOrganizations from './useOrganizations.js';
import useOrgId from './useOrgId.js';

const useOrgType = () => {
  const orgId = useOrgId();
  const { data: organizations } = useOrganizations();
  const currentOrganization = organizations?.find(({ id }) => id === orgId);
  if (!currentOrganization) return undefined;
  return currentOrganization.type || 'default';
};

export default useOrgType;
